import { EntityVariationImple } from "../entity/EntityVariationImple";

export class DtoVariationsPostResImple extends EntityVariationImple {}
